import { supabase } from "@/lib/supabase";

export interface InviteEmailResult {
  sent: boolean;
  reason?: string;
}

/**
 * Send the invitation email for a pending invitation via the backend email
 * function. Returns an honest result so the UI can distinguish "sent" from
 * "email delivery isn't configured yet".
 */
export async function sendInviteEmail(
  email: string,
  orgName: string,
  role: string,
  token?: string,
): Promise<InviteEmailResult> {
  const base = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const pathPrefix = base ? `/${base}` : "";
  const appUrl = `${window.location.origin}${pathPrefix}`;
  try {
    const { data, error } = await supabase.functions.invoke("send-invitation", {
      body: { email, org_name: orgName, role, token, app_url: appUrl },
    });
    if (error) return { sent: false, reason: "error" };
    return { sent: !!data?.sent, reason: data?.reason as string | undefined };
  } catch {
    return { sent: false, reason: "error" };
  }
}